import { combineReducers } from 'redux'
import theme from 'store/slices/themeSlice'
import auth from 'store/slices/authSlice'
import manageModuleGroupSlice from 'store/slices/ManageModuleGroupSlice/manageModuleGroupSlice'
import manageModuleSlice from 'store/slices/ManageModuleSlice/manageModuleSlice'
//_import_slice_here
    import manageAttemptQuizSlice from './slices/AttemptQuiz/manageAttemptQuizSlice';
    import manageManageEnrollementSlice from './slices/ManageEnrollement/manageManageEnrollementSlice';
    import manageUploadQuizSlice from './slices/UploadQuiz/manageUploadQuizSlice';
    import manageSubjectSlice from './slices/Subject/manageSubjectSlice';
    import manageCourseSlice from './slices/Course/manageCourseSlice';
    import manageLookupsSlice from './slices/Lookups/manageLookupsSlice';
    import manageManageUserSlice from './slices/ManageUser/manageManageUserSlice';
    import manageManageRolePermissionSlice from './slices/ManageRolePermission/manageManageRolePermissionSlice';
    import manageManageRoleSlice from './slices/ManageRole/manageManageRoleSlice';
    import manageManagePermissionsSlice from './slices/ManagePermissions/manageManagePermissionsSlice';
    import manageUsersSecuritySlice from './slices/UsersSecurity/manageUsersSecuritySlice';


const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        manageModuleGroupSlice,
        manageModuleSlice,
        //_Register_slice_after
    manageAttemptQuizSlice,
    manageManageEnrollementSlice,
    manageUploadQuizSlice,
    manageSubjectSlice,
    manageCourseSlice,
    manageLookupsSlice,
    manageManageUserSlice,
    manageManageRolePermissionSlice,
    manageManageRoleSlice,
    manageManagePermissionsSlice,
    manageUsersSecuritySlice,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
